<template>
  <v-app-bar class="page-header-ctr">
    <v-flex lg2>
      <v-layout justify-start>
        <img
          class="header-logo"
          autoid="img-env-yodlee"
          src="../assets/images/envestnet-yodlee.svg"
          alt="logo"
        />
      </v-layout>
    </v-flex>
    <v-flex lg8>
      <v-layout justify-center>
        <div autoid="lbl-header" class="title-text" v-if="showHeaderText"></div>
      </v-layout>
    </v-flex>
    <v-flex lg2>
      <v-layout v-show="showMenu == true" justify-end>
        <!-- <v-btn class="avatar" icon>
          <v-icon light>account_circle</v-icon>
        </v-btn>-->
        <v-menu class="header-actions" bottom origin="center center" transition="scale-transition">
          <template v-slot:activator="{ on }">
            <!-- <v-btn color="primary" dark v-on="on">Scale Transition</v-btn> -->
            <v-btn :ripple="false" depressed v-on="on" class="header-action-btn">
              <v-icon light>account_circle</v-icon>
              <span>{{userName}}</span>
            </v-btn>
          </template>
          <v-list class="header-actions">
            <v-list-item class="user-name">
              <v-icon light>account_circle</v-icon>
              <span>{{userName}}</span>
              <!-- <v-list-item-title></v-list-item-title> -->
            </v-list-item>
            <v-list-item
              class="header-menu-item"
              v-for="(item, i) in items"
              :key="i"
              @click="headerActions(item)"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-layout>
    </v-flex>
  </v-app-bar>
</template>

<script>
import serviceRegistery from '../mixins/serviceRegistery'

export default {
  data() {
    return {
      config: this.headerConfig,
      title: this.headerConfig.headerText,
      items: [
        // { title: 'Profile', action: 'profile' },
        { title: 'Log Out', action: 'logout' }
      ]
    }
  },
  props: {
    headerConfig: Object
  },
  computed: {
    showMenu() {
      return this.headerConfig.showMenu
    },
    userName() {
      return this.headerConfig.userName
    },
    showHeaderText() {
      return this.$store.state.appStore.showHeaderText
    }
  },
  methods: {
    headerActions(item) {
      switch (item.action) {
        case 'logout':
          this.logout()
          break
        case 'profile':
          this.loadProfile()
          break
        default:
          console.log('Invalid header actions')
      }
    },
    logout() {
      serviceRegistery
        .makeCall({
          url: this.$hostname + 'services/authenticator/logout',
          method: 'POST'
        })
        .then(response => {
          window.location.assign(this.$hostname)
        })
        .catch(error => {
          window.location.assign(this.$hostname)
        })
    },
    loadProfile() {}
  }
}
</script>

<style lang="scss">
.header-logo {
  line-height: initial;
}
.header-action-btn {
  color: #888888 !important;
  background-color: #ffffff !important;
  height: 48px !important;
  &::before {
    opacity: 0 !important;
  }
  &:hover {
    color: #0070c9 !important;
    background-color: #ffffff !important;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25) !important;
  }
  .v-btn__content {
    span {
      margin-left: 14px;
      font-size: 14px;
      text-transform: none;
    }
  }
}
.header-actions {
  .user-name {
    .v-icon,
    span {
      color: #0070c9 !important;
    }
    span {
      margin-left: 14px;
      font-size: 14px;
      // text-transform: none !important;
    }
    .v-list-item {
      height: 32px !important;
      min-height: 32px;
      margin-bottom: 20px;
    }
  }
  .header-menu-item {
    color: #0070c9 !important;
    background-color: #ffffff !important;
    font-size: 15px;
    height: 32px !important;
    min-height: 32px;
    line-height: 32px;
    &::before {
      opacity: 0;
    }
    .v-list-item__title {
      color: #0070c9 !important;
      font-size: 15px;
      height: 32px !important;
      min-height: 32px;
      line-height: 32px;
    }
  }
}

.page-header-ctr {
  margin: 0 24px;
  height: 72px;
  line-height: 70px;
}
.v-toolbar {
  box-shadow: none !important;
  background-color: #ffffff !important;
}
img {
  width: 115px;
  height: 60px;
}
button.avatar {
  width: 115px;
}
.page-header-ctr .v-toolbar__content {
  justify-content: center !important;
  padding: 0 !important;
}
.v-application .title-text {
  color: #888888 !important;
  font-size: 25px !important;
  font-weight: 300 !important;
  text-align: center !important;
  font-family: 'Lato', Arial !important;
}
</style>
